// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:34:48.391Z
// Property: Quinn Residences at Drayton Park (ID: 6767906449167577)
// Collections: 20 amenities, 7 floorplans (live), 19 photos, 44 POIs, 2 reviews, 3 virtual tours, 5 office hours, 1 special offers (live), 20 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167577",
  "property_external_id": "1661775",
  "property_zillow_url": "https://www.zillow.com/apartments/pooler-ga/quinn-residences-at-drayton-park-savannah-quarters/CrH6n3/",
  "property_apartments_url": "https://www.apartments.com/quinn-residences-at-drayton-park-savannah-quarters-pooler-ga/9nb6s54/",
  "property_google_business_url": "https://www.google.com/maps/place/Drayton+Park+-+a+Quinn+Residence/@32.0680037,-81.2580667,1189m/data=!3m1!1e3!4m6!3m5!1s0x88fba7a1d1c7a12f:0xbfa2bb1ad2885645!8m2!3d32.0676573!4d-81.2570948!16s%2Fg%2F11pb_p4s2m?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57146903863",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "drayton-park-at-savannah-corners",
  "property_name": "Quinn Residences at Drayton Park",
  "property_website_url": "https://www.draytonparkhomes.com",
  "property_domain": "https://www.draytonparkhomes.com",
  "property_address": "99 Fern Road",
  "property_full_address": "99 Fern Rd, Pooler, GA 31322",
  "property_address_1": "99 Fern Road",
  "property_address_2": null,
  "property_address_city": "Pooler",
  "property_address_state": "GA",
  "property_address_zip_full": "31322",
  "property_address_zip": "31322",
  "property_address_country": "US",
  "property_address_county": "Chatham County",
  "property_neighborhood_address": "Pooler/Bloomingdale",
  "property_address_latitude": "32.06761",
  "property_address_longitude": "-81.25718",
  "property_email": "DraytonPark.RENTCafecomILS.Quinn@assist.rent",
  "property_phone": "(866) 761-5741",
  "property_call_tracking_phone": "866-761-5741",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Room to live, minutes from Savannah.</strong> Explore polished three- and four-bedroom rental homes with fenced yards, 2-car garages, smart-home technology, in-home laundry, upscale finishes, and lawn maintenance—all in Pooler’s Drayton Park at Savannah Quarters. Schedule your tour today.</p>",
  "property_long_description": "<p><strong>Room to live, minutes from Savannah.</strong> At Quinn Residences at Drayton Park, you get the feel of a single-family home in one of Pooler’s newest master-planned settings: Drayton Park at Savannah Quarters. Choose from spacious three- and four-bedroom layouts with fenced yards, 2-car garages, smart-home technology, in-home washer and dryer, solid-surface countertops, luxury flooring, and lawn maintenance that keeps weekends simpler.</p><p>Beyond your front door, the <a href=\"/amenities\">community amenities</a> add everyday ease with a pool, dog park, grill area, playground, and on-site maintenance. Your Pooler/Bloomingdale location puts I-16, I-95, Savannah/Hilton Head International Airport, and Historic Savannah within easy reach, while everyday shopping, dining, and entertainment cluster along Pooler Parkway and Tanger Outlets. Spend time at Tom Triplett Community Park, catch a movie at Royal Cinemas IMAX, or explore the National Museum of the Mighty Eighth Air Force—then come home to a polished rental home with space, privacy, and Lowcountry convenience.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3902-72fb-b1c6-d34b2ca38482.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a two-story home with a two-car garage and gray siding.",
    "public_id": "019fba10-3902-72fb-b1c6-d34b2ca38482",
    "storage_key": "property/6767906449167577/019fba10-3902-72fb-b1c6-d34b2ca38482.webp",
    "width": 1280,
    "height": 920
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167577/01a0c013-c8f8-763c-9fee-cf9de6a282ae.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c013-c8f8-763c-9fee-cf9de6a282ae",
    "storage_key": "property/6767906449167577/01a0c013-c8f8-763c-9fee-cf9de6a282ae.mp4",
    "thumbnail_key": "property/6767906449167577/01a0c013-c8f8-763c-9fee-cf9de6a282ae_thumb.webp",
    "size_bytes": 29436852,
    "classification": "Community",
    "title": "Discover Your Dream Home: Community Amenities and Overview",
    "description": "Explore the vibrant community with its stunning pool, lush green spaces, and beautiful homes. Experience the lifestyle offered."
  },
  "property_total_units": "97",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": "0",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "79.16666666666666",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge package $10.95, landscaping $100, smart home package $35, solar fee $90; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://draytonparkhomes.securecafe.com/onlineleasing/drayton-park/floorplans.aspx",
  "property_resident_portal_url": "https://draytonparkhomes.securecafenet.com/residentservices/drayton-park/userlogin",
  "property_apply_now_url": "https://draytonparkhomes.securecafe.com/onlineleasing/drayton-park/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a0cf93-54c0-74ba-a748-a5649df6a23e.webp",
  "property_primary_logo_media": {
    "alt_text": "Quinn Residences at Drayton Park Savannah Quarters logo.",
    "public_id": "01a0cf93-54c0-74ba-a748-a5649df6a23e",
    "storage_key": "property/6767906449167577/01a0cf93-54c0-74ba-a748-a5649df6a23e.webp",
    "width": 179,
    "height": 64
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a0cf93-bc0c-708c-9f2c-1f36a10c47d0.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0cf93-bc0c-708c-9f2c-1f36a10c47d0",
    "storage_key": "property/6767906449167577/01a0cf93-bc0c-708c-9f2c-1f36a10c47d0.webp",
    "width": 179,
    "height": 64
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a0cf93-b0cd-75d4-be2f-d1d6f26fda56.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0cf93-b0cd-75d4-be2f-d1d6f26fda56",
    "storage_key": "property/6767906449167577/01a0cf93-b0cd-75d4-be2f-d1d6f26fda56.webp",
    "width": 179,
    "height": 64
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#275f64",
  "property_secondary_color": "#606161",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 3",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "3.5",
  "property_sqft_range": "1735 - 2146",
  "property_sqft_min": "1735",
  "property_sqft_max": "2721",
  "property_price_range": "2233 - 2898",
  "property_price_min": "2233",
  "property_price_max": "3052",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=100066543527728",
  "property_instagram_url": "https://www.instagram.com/draytonparkhomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJL6HH0aGn-4gRRVaI0hq7or8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/drayton-park-homes-pooler",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Quinn Residences at Drayton Park",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Rental Home",
  "property_home_amenities_blurb": "<p><strong>Low-maintenance comfort, inside and out.</strong> At Quinn Residences at Drayton Park, single-family rental homes bring together polished finishes, smart-home features, energy-efficient appliances, in-home laundry, spacious closets, 2-car garages, and fenced yards. Just beyond your door, enjoy a refreshing pool, grill area, dog park, lawn maintenance, and on-site maintenance—all designed to make everyday living in Pooler feel effortless.</p>",
  "property_home_floorplans_blurb": "<p><strong>Three- and four-bedroom rental homes with room to flex.</strong><br>Explore single-family layouts with open gathering spaces, well-planned kitchens, upstairs bedroom retreats, generous storage, and attached 2-car garages. Select plans add extra separation for guests, hobbies, or work-from-home space, while solid-surface countertops, luxury flooring, smart-home features, in-home laundry, and fenced yards bring everyday ease into focus.</p>",
  "property_home_gallery_blurb": "<p><strong>See single-family rental homes in Pooler.</strong> Browse bright interiors with open layouts, granite countertops, stainless steel appliances, modern cabinetry, laminate flooring, dual-sink vanities, in-unit laundry, and smart home touches. Then take a look outside at the pool, grill area, maintained lawns, and green spaces that bring extra room to unwind beyond the front door.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Pooler convenience, Savannah Quarters ease.</strong> Quinn Residences at Drayton Park places everyday stops close to home, from coffee, groceries, fitness, and dining along Pooler Parkway to shopping and restaurants at Tanger Outlets. For fresh air, Tom Triplett Community Park brings trails, a lake, disc golf, and open green space, while I-16 and I-95 keep Historic Savannah within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents give the team high marks.</strong> Reviews for Quinn Residences at Drayton Park call out responsive management, prompt follow-up, and dependable maintenance support. From Kaily and Gabriella’s clear communication to helpful service from Antonio and Samuel, the feedback points to a team that keeps day-to-day living running smoothly in these single-family rental homes.</p>",
  "property_neighborhood_blurb": "<p><strong>From quiet mornings to quick nights out, Pooler keeps your routine close.</strong> Set within Savannah Quarters, Quinn Residences at Drayton Park puts you near the westside’s everyday conveniences without losing the easygoing feel of a single-family home neighborhood. Coffee runs, grocery stops, fitness studios, and casual dinners cluster around Pooler Parkway and The Village at Savannah Quarters, while Tanger Outlets brings shopping, restaurants, and weekend browsing a short drive away.</p><p>When you want room to roam, Tom Triplett Community Park offers trails, a lake, disc golf, and wide-open green space. For a change of pace, head to Royal Cinemas &amp; IMAX, the National Museum of the Mighty Eighth Air Force, or Historic Savannah via nearby I-16 and I-95. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location connects with your day-to-day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, built into the details.</strong> At Quinn Residences at Drayton Park, your single-family rental home pairs polished interiors with outdoor space and community perks that make daily living feel more effortless. Cook with energy-efficient appliances and solid-surface countertops, enjoy the convenience of an in-home washer and dryer, organize with large closets, and settle into smart-home features, luxury flooring, dual-sink vanities, 2-car garages, and fenced yards.</p><p>Beyond your door, take advantage of a refreshing pool, grill area, dog park, lawn maintenance, and on-site maintenance in a Pooler setting designed for low-maintenance comfort. Explore the <a href=\"/gallery\">amenity photos</a>, compare available <a href=\"/floor-plans\">home layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready for more room near Savannah?</strong> Start your application for a three- or four-bedroom rental home with a fenced yard, 2-car garage, smart-home technology, and polished finishes—plus lawn maintenance that helps keep weekends simple.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The leasing team at Quinn Residences at Drayton Park is here to help you explore spacious three- and four-bedroom rental homes with fenced yards, 2-car garages, and smart-home comfort—minutes from Savannah in Pooler’s Drayton Park at Savannah Quarters.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at Quinn Residences at Drayton Park?</strong> Start here for quick answers about the community, leasing, home features, and everyday details. From spacious layouts to fenced yards and smart-home technology, this FAQ page helps you plan your next step—and the leasing team is happy to help with anything else.</p>",
  "property_floorplans_blurb": "<p><strong>Find the home shape that fits the way you live.</strong><br>Quinn Residences at Drayton Park offers a focused collection of three- and four-bedroom single-family rental homes, with layouts that make everyday routines feel more natural—from open gathering spaces and well-planned kitchens to upstairs bedroom retreats, generous storage, and attached 2-car garages. Choose a plan with the bath count, bedroom separation, and extra flex you want, whether that means a streamlined three-bedroom design or a larger four-bedroom home with added privacy for guests, hobbies, or work-from-home space.</p><p>Inside, finishes like solid-surface countertops, luxury flooring, smart-home features, in-home laundry, and fenced yards bring polish and practicality together. Browse the available floor plans below, compare current pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture your space before you ever step inside.</strong> The photo gallery at Drayton Park at Savannah Corners gives you a closer look at bright, single-family rental homes in Pooler, from open living areas with easy-flow layouts to kitchens framed by granite countertops, stainless steel appliances, and clean modern cabinetry.</p><p>Scroll through images of everyday details that make the home feel finished: laminate flooring, generous closet space, dual-sink vanities, in-unit laundry, and smart home touches designed to keep routines simple. Outside, see the pool, grill area, maintained lawns, and community green spaces that add more room to relax beyond your front door.</p><p>After you browse the gallery, compare <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">features and finishes</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Drayton Park from the map.</strong> Find available three- and four-bedroom rental homes, then zoom out to see how this Pooler location connects to I-16, I-95, the airport, Historic Savannah, and everyday shopping, dining, and entertainment along Pooler Parkway.</p>",
  "property_pets_blurb": "<p><strong>A pet-friendly home base with space to spare.</strong> At Quinn Residences at Drayton Park, your dog or cat can fit naturally into the rhythm of home—from a fenced yard for fresh-air breaks to a community dog park for extra tail-wagging time. Inside your single-family rental home, easy-care luxury flooring, in-home laundry, large closets, and a patio help keep bowls, beds, leashes, and muddy-paw cleanup feeling manageable.</p><p>When you want to unwind close to home in Pooler, the <a href=\"/amenities\">pet-minded community features</a> add convenience without overcomplicating your day. Review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Drayton Park makes everyday life with pets feel a little more comfortable.</p>",
  "property_referafriend_blurb": "<p><strong>Share the room to live you love.</strong> Invite friends to discover spacious three- and four-bedroom rental homes with fenced yards, 2-car garages, smart-home technology, and lawn maintenance in Drayton Park at Savannah Quarters—minutes from Savannah, with everyday convenience close to home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Quinn Residences at Drayton Park account—so you can get back to enjoying the space, smart-home convenience, and easy living that make home feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> At Quinn Residences at Drayton Park, reviews highlight the people behind the home experience—responsive property management, returned calls and emails, and a maintenance team residents trust when service is needed.</p><p>You’ll find praise for Kaily and Gabriella’s communication, along with shoutouts for Antonio and Samuel, described as “very pleasant to deal with” and helpful with home servicing needs. As you read through the ratings below, you’ll get a clearer sense of how the team supports day-to-day living in these single-family rental homes.</p>",
  "property_created_at": "1785532424788",
  "property_scheduletour_blurb": "<p><strong>See the space for yourself.</strong> Tour Quinn Residences at Drayton Park and experience spacious three- and four-bedroom rental homes with fenced yards, 2-car garages, smart-home technology, and polished finishes—minutes from Savannah. Schedule your visit today and picture weekends made simpler with lawn maintenance included.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The leasing team will be in touch soon with more details. In the meantime, picture the ease of a polished three- or four-bedroom rental home with a fenced yard, 2-car garage, smart-home features, and room to live just minutes from Savannah.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layout before you make the drive.</strong> Explore Quinn Residences at Drayton Park from wherever you are with immersive Matterport tours of the Cumberland, Sapelo, and Richmond Hill homes. Move room by room to get a real sense of the entry flow, open living areas, kitchen sightlines, bedroom separation, storage, and everyday finishes that photos alone can’t fully show. As you tour, notice the details that shape daily use—hard-surface flooring, polished countertops, modern appliances, in-home laundry spaces, and attached-garage convenience. Compare these featured virtual tours with the full collection of <a href=\"/floor-plans\">available floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> in Pooler when you’re ready to see your preferred home in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Quinn Residences at Drayton Park",
  "property_seo_title_home": "Quinn Residences at Drayton Park |  Apartments in Pooler, GA",
  "property_seo_description_home": "Discover modern living at Quinn Residences, Pooler, GA. Enjoy spacious 3-4 bedroom homes with luxury amenities and smart tech. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Pooler, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Quinn Residences in Pooler, GA! Choose from spacious three or four-bedroom floor plans tailored for modern living. Browse now!",
  "property_seo_title_amenities": "Amenities | Pooler, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Quinn Residences in Pooler, GA. Enjoy large closets, smart home tech, and a resort-style pool—all designed for your comfort.",
  "property_seo_title_gallery": "Gallery | Apartments in Pooler, GA",
  "property_seo_description_gallery": "Capture your dream lifestyle at Quinn Residences! With spacious floor plans, luxury amenities, and inviting spaces, envision your perfect home in Pooler, GA.",
  "property_seo_title_virtualtours": "Virtual Tours | Quinn Residences at Drayton Park Apartments",
  "property_seo_description_virtualtours": "Explore Quinn Residences at Drayton Park! Discover spacious 3- and 4-bedroom floor plans. Take a virtual tour of your future home in Pooler, GA!",
  "property_seo_title_interactivemap": "Interactive Map | Quinn Residences at Drayton Park Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Quinn Residences, Pooler, GA! Explore our interactive map for floor plans, amenities, and pricing of 3- or 4-bedroom apartments.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Pooler, GA",
  "property_seo_description_neighborhood": "Uncover local gems near Quinn Residences at Drayton Park! Dive into nearby favorites and vibrant spots in Pooler, GA that enrich your lifestyle today.",
  "property_seo_title_contact": "Contact Us | Quinn Residences at Drayton Park",
  "property_seo_description_contact": "Connect with Quinn Residences at Drayton Park! Explore spacious 3- and 4-bedroom floor plans in Pooler, GA. Our leasing team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Pooler, GA",
  "property_seo_description_faqs": "Got questions? Dive into Quinn Residences at Drayton Park's FAQs for insights on luxury amenities, spacious floor plans, and life in Pooler, GA!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Pooler, GA",
  "property_seo_description_reviews": "Experience life at Quinn Residences in Pooler! From spacious layouts to luxury amenities, see why residents love calling this community home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Pooler, GA",
  "property_seo_description_applynow": "Discover luxury living at Quinn Residences in Pooler, GA. Choose from spacious 3- and 4-bedroom floor plans with top-notch amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Quinn Residences at Drayton Park",
  "property_seo_description_residentaccess": "Stay connected at Quinn Residences! Log in to your resident portal for easy rent payments, maintenance requests, and everything you need to call Pooler home.",
  "property_seo_title_referafriend": "Refer A Friend | Quinn Residences at Drayton Park",
  "property_seo_description_referafriend": "Refer a friend to Quinn Residences at Drayton Park in Pooler, GA! Build a community where great friends become great neighbors. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Quinn Residences at Drayton Park",
  "property_seo_description_scheduletour": "Experience modern living at Quinn Residences in Pooler, GA. Schedule a tour today and find your perfect home in a vibrant community that welcomes you!",
  "property_seo_title_privacy": "Privacy Policy | Quinn Residences at Drayton Park",
  "property_seo_description_privacy": "Protecting your personal space matters. Learn more about Quinn Residences at Drayton Park's commitment to your privacy in Pooler, GA. View our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Quinn Residences at Drayton Park",
  "property_seo_description_accessibility": "At Quinn Residences at Drayton Park in Pooler, GA, we champion digital inclusion, ensuring everyone can enjoy our vibrant community with ease and comfort.",
  "property_seo_title_sitemap": "Sitemap | Quinn Residences at Drayton Park",
  "property_seo_description_sitemap": "Uncover every corner of Quinn Residences at Drayton Park in Pooler, GA. Navigate our sitemap for effortless access to amenities, floor plans, and more!",
  "property_seo_title_thankyou": "Thank You | Quinn Residences at Drayton Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Quinn Residences at Drayton Park! Our team will connect with you soon to help you find your perfect Pooler apartment.",
  "property_seo_title_pets": "Pet Policy | Apartments in Pooler, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793296018737",
  "amenities": [
    {
      "id": "custom_4fe37919-5f77-4f62-a239-4b552aca1570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124555",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e78280fd-70cf-4f24-a441-a516a7b9c15a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122203675",
      "title": "Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86d63692-da9b-488d-917f-f03783756ca4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122203674",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69594422-7568-4ce5-a83e-50f6aa69d8b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124545",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b73e9dc-1767-4b9d-a08a-bcde580c55d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124534",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b6826e2-dd67-4a8a-9115-5b758d99b332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615684",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3356f518-abac-461a-9175-07798a39c95c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615683",
      "title": "Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_775b77bb-4dd3-4e3b-8dbd-e74f6e268f6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615680",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72dccc59-2fa2-40e5-a1bf-ba042b7a8a4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615681",
      "title": "Energy-Efficient Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f4ff5ea-acf0-4205-9dd6-a41a96971ce2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615682",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f78a3fe-48ff-49f5-91f8-b1ac93d1e90b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615679",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f282db4a-576f-4014-b8df-5e3983423cb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122203676",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27561415-89f9-4ddf-af42-85a07ee02ef6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "122615678",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96b65b48-2e4f-4808-8fdc-72d0cf375aa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124563",
      "title": "Grill Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d323a65b-af40-41af-a90e-f4fb8a1c9cbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124541",
      "title": "2-Car Garages",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_304ed91e-5955-461b-91fc-32e6eb395009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124548",
      "title": "Smart Home Technology",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9f66ec1-dca3-4526-b5cf-5dfaaba22a78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "129124551",
      "title": "Dual-Sink Vanity",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_22c99d60-3eed-43fb-a2c2-8f591a98a26c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d496cb45-656e-47b0-ae57-3898caf79e59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "false",
      "title": "Solid-Surface Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_606347f4-9080-4160-8b1c-abba81c2561e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "external_id": "false",
      "title": "Fenced Yards",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_9f02e31d93dccf51dffbe255",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3902-72fb-b1c6-d34b2ca38482.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story home with a two-car garage and gray siding.",
        "public_id": "019fba10-3902-72fb-b1c6-d34b2ca38482",
        "storage_key": "property/6767906449167577/019fba10-3902-72fb-b1c6-d34b2ca38482.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "This is the exterior of a home, featuring a large two-car garage and gray siding. The house has a classic design with a pitched roof and multiple windows.",
      "link": "false",
      "alt_text": "A two-story house with a garage door in the front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/beaufort-exterior.jpg"
    },
    {
      "id": "ec_601de66abee74af6c76d458f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-400e-7184-b3f5-9189eac1f279.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and island.",
        "public_id": "019fba10-400e-7184-b3f5-9189eac1f279",
        "storage_key": "property/6767906449167577/019fba10-400e-7184-b3f5-9189eac1f279.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "This spacious kitchen features a large island with a double sink, ample cabinet space, and sleek stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "A modern kitchen with white cabinets and a wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-kitchen.jpg"
    },
    {
      "id": "ec_03422cd94f4e9bbe4a824019",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-48bf-7229-b651-e17ea78b095b.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment kitchen and living area with stairs.",
        "public_id": "019fba10-48bf-7229-b651-e17ea78b095b",
        "storage_key": "property/6767906449167577/019fba10-48bf-7229-b651-e17ea78b095b.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment interior featuring a fully equipped kitchen, open-plan living area, and a stylish staircase. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A modern kitchen with a staircase leading to the upper floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/sapelo-living.jpg"
    },
    {
      "id": "ec_616d00916cb12f4329802d98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3823-76fb-95ce-c588951b738a.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with blue siding, a white garage door, and a black front door.",
        "public_id": "019fba10-3823-76fb-95ce-c588951b738a",
        "storage_key": "property/6767906449167577/019fba10-3823-76fb-95ce-c588951b738a.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming two-story home featuring elegant blue siding, a spacious white garage, and a welcoming black front door, offering comfortable living.",
      "link": "false",
      "alt_text": "A blue house with a white garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/amelia-exterior.jpg"
    },
    {
      "id": "ec_eb00e0c06fa46b974ba7555b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3990-73b8-9402-7d70ca98e229.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fba10-3990-73b8-9402-7d70ca98e229",
        "storage_key": "property/6767906449167577/019fba10-3990-73b8-9402-7d70ca98e229.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, stainless steel appliances, and elegant granite countertops. Perfect for culinary enthusiasts.",
      "link": "false",
      "alt_text": "A modern kitchen with white cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/beaufort-kitchen.jpg"
    },
    {
      "id": "ec_c5b0f83cb82a32099101507d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3789-7304-9f65-cb7329046396.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a dining area.",
        "public_id": "019fba10-3789-7304-9f65-cb7329046396",
        "storage_key": "property/6767906449167577/019fba10-3789-7304-9f65-cb7329046396.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and bright kitchen featuring elegant white cabinetry, granite countertops, and modern stainless steel appliances, flowing seamlessly into a dining area.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a black stove top oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/amelia-kitchen.jpg"
    },
    {
      "id": "ec_7b41fa5ad0e52e19da14b8fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-4d1e-709d-8742-b5164b9c0a5d.webp",
      "image_media": {
        "alt_text": "Exterior of a blue two-story house with a white garage door and black shutters.",
        "public_id": "019fba10-4d1e-709d-8742-b5164b9c0a5d",
        "storage_key": "property/6767906449167577/019fba10-4d1e-709d-8742-b5164b9c0a5d.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Charming blue house featuring a modern white garage door, elegant black shutters, and a well-maintained lawn, offering a welcoming curb appeal.",
      "link": "false",
      "alt_text": "A blue house with a white garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/tybee-exterior.jpg"
    },
    {
      "id": "ec_06efc233526dd1d76077cf11",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-43a7-7667-bdbe-1f89169587d1.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a two-car garage and a covered front entrance.",
        "public_id": "019fba10-43a7-7667-bdbe-1f89169587d1",
        "storage_key": "property/6767906449167577/019fba10-43a7-7667-bdbe-1f89169587d1.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Charming two-story home featuring a spacious two-car garage and a welcoming covered front entrance. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A two-story house with a garage is shown in the image.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/richmond-hill-exterior.jpg"
    },
    {
      "id": "ec_50d1e4d495219286e85845f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-4307-7435-b997-d7eabff30654.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a double garage door and light gray siding.",
        "public_id": "019fba10-4307-7435-b997-d7eabff30654",
        "storage_key": "property/6767906449167577/019fba10-4307-7435-b997-d7eabff30654.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming two-story home featuring a spacious double garage and a welcoming exterior design.",
      "link": "false",
      "alt_text": "A two-story house with a garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/edisto-exterior.jpg"
    },
    {
      "id": "ec_2f684f81ffd1bb3980b16814",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover this charming suburban community, featuring beautiful homes arranged along scenic, winding streets, offering a peaceful and picturesque living environment.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential neighborhood with houses and streets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-1.jpg"
    },
    {
      "id": "ec_d346b4208c64d73d3837f93c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2c6b-74f7-866a-2c8e68dca010.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban street lined with houses and parked cars.",
        "public_id": "019fba10-2c6b-74f7-866a-2c8e68dca010",
        "storage_key": "property/6767906449167577/019fba10-2c6b-74f7-866a-2c8e68dca010.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover this charming community featuring beautifully designed homes with spacious driveways and well-manicured lawns. A perfect place to call home.",
      "link": "false",
      "alt_text": "A residential street with houses on both sides and cars parked on the side.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-2.jpg"
    },
    {
      "id": "ec_f6e565ac49dc41b3042b8acc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2e2a-70b5-baa4-490ab0a70a02.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool and adjacent amenity building at a multifamily property.",
        "public_id": "019fba10-2e2a-70b5-baa4-490ab0a70a02",
        "storage_key": "property/6767906449167577/019fba10-2e2a-70b5-baa4-490ab0a70a02.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style outdoor pool, complete with comfortable lounge seating and shaded cabanas. Perfect for relaxation and recreation.",
      "link": "false",
      "alt_text": "An aerial view of a pool surrounded by lawn chairs and a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-6.jpg"
    },
    {
      "id": "ec_1a50578583a10cd1b4063486",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2d35-7573-acaa-38dca52ef802.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with covered seating area and palm trees.",
        "public_id": "019fba10-2d35-7573-acaa-38dca52ef802",
        "storage_key": "property/6767906449167577/019fba10-2d35-7573-acaa-38dca52ef802.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing or socializing. The covered patio area offers shade on sunny days.",
      "link": "false",
      "alt_text": "A sunny day at the pool with a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-5.jpg"
    },
    {
      "id": "ec_3d1acb70e28f5e83afec8e5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2cfd-7085-90f3-c30b959c985f.webp",
      "image_media": {
        "alt_text": "Covered pavilion and pier on the edge of a lake, surrounded by trees under a cloudy sky.",
        "public_id": "019fba10-2cfd-7085-90f3-c30b959c985f",
        "storage_key": "property/6767906449167577/019fba10-2cfd-7085-90f3-c30b959c985f.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community's covered pavilion and serene lake, perfect for gatherings and relaxation.",
      "link": "false",
      "alt_text": "A large building sits by a body of water with a dock leading to it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/park(1).jpg"
    },
    {
      "id": "ec_bde70bd4563450614579708e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2d2c-70a9-980a-f3ffc0dc7576.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings overlooking a pond with houses in the background.",
        "public_id": "019fba10-2d2c-70a9-980a-f3ffc0dc7576",
        "storage_key": "property/6767906449167577/019fba10-2d2c-70a9-980a-f3ffc0dc7576.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with slides and swings, set against a scenic pond and charming neighborhood backdrop.",
      "link": "false",
      "alt_text": "A playground with a slide and a tower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/aerial-8.jpg"
    },
    {
      "id": "ec_5fec5bf77027a87b94fa4c53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-39c2-726d-8806-a3e896b22856.webp",
      "image_media": {
        "alt_text": "Exterior of a single-family home with a tan siding, white garage door, and front door.",
        "public_id": "019fba10-39c2-726d-8806-a3e896b22856",
        "storage_key": "property/6767906449167577/019fba10-39c2-726d-8806-a3e896b22856.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Charming single-family home exterior featuring tan siding, a white garage door, and an inviting front entrance.",
      "link": "false",
      "alt_text": "A two-car garage is attached to a house.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/cumberland-exterior.jpg"
    },
    {
      "id": "ec_8aa13084693ad1524281d9d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-436b-7099-8ad7-0e86d1670d86.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and an island.",
        "public_id": "019fba10-436b-7099-8ad7-0e86d1670d86",
        "storage_key": "property/6767906449167577/019fba10-436b-7099-8ad7-0e86d1670d86.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and bright kitchen featuring white cabinetry, a subway tile backsplash, stainless steel appliances, and a large island perfect for meal prep and casual dining.",
      "link": "false",
      "alt_text": "A modern kitchen with white cabinets and a wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/richmond-hill-kitchen.jpg"
    },
    {
      "id": "ec_91b54a5bfdd001f5810127e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-4446-701e-9f94-3319c2b4e8ce.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story light blue vinyl siding house with a white garage door, black shutters, and a black front door.",
        "public_id": "019fba10-4446-701e-9f94-3319c2b4e8ce",
        "storage_key": "property/6767906449167577/019fba10-4446-701e-9f94-3319c2b4e8ce.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Charming two-story home featuring light blue vinyl siding, a spacious white garage door, and classic black shutters on the windows.",
      "link": "false",
      "alt_text": "A two-story house with a garage door and a driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/sapelo-exterior.jpg"
    },
    {
      "id": "ec_0ef774416593c4977f81976f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-4d41-75f8-a071-5d89b3acad7e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a kitchen island.",
        "public_id": "019fba10-4d41-75f8-a071-5d89b3acad7e",
        "storage_key": "property/6767906449167577/019fba10-4d41-75f8-a071-5d89b3acad7e.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring elegant white cabinetry, durable granite countertops, and a full suite of stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/tybee-kitchen.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0206c333-6ce7-48af-b43d-ed6c556df2e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "POOLER - Big Bon Bodega",
      "poi_type": "Restaurants",
      "poi_address": "100 Blue Moon Xing Suite 115, Pooler, GA 31322, USA",
      "poi_short_description": "Bagel and breakfast café; Pooler location of Savannah's Big Bon Bodega.",
      "poi_long_description": "Bagel and breakfast café; Pooler location of Savannah's Big Bon Bodega.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-ae30-729d-8d88-819b6a38c50b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-ae30-729d-8d88-819b6a38c50b",
        "storage_key": "property/6767906449167577/019fba08-ae30-729d-8d88-819b6a38c50b.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://bigbonbodega.com/pooler?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3551315061350966516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pooler---big-bon-bodega",
      "poi_latitude": "32.0806058",
      "poi_longitude": "-81.2834402",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-250-7921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Wu_Grin-4gR9KRRjTvOSDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e1d0be91-d7d2-47cc-904f-da6d8cf3dc23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "The Taco Stache",
      "poi_type": "Restaurants",
      "poi_address": "100 Blue Moon Xing Ste 111, Pooler, GA 31322, USA",
      "poi_short_description": "Casual local restaurant featuring a menu of creative tacos and other Mexican dishes, along with burgers and fajitas.",
      "poi_long_description": "Casual local restaurant featuring a menu of creative tacos and other Mexican dishes, along with burgers and fajitas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-3890-713f-89a9-899863e95213.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-3890-713f-89a9-899863e95213",
        "storage_key": "property/6767906449167577/01a086ad-3890-713f-89a9-899863e95213.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thetacostache.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9070138539128526434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-taco-stache",
      "poi_latitude": "32.0805309",
      "poi_longitude": "-81.2838611",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-737-3796",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUbTnhKn-4gRYhZWGPKa330",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0958402a-f296-4d5a-849b-0b1817c9624f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "The Sauce Italian Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "100 Blue Moon Xing Ste 110, Pooler, GA 31322, USA",
      "poi_short_description": "Italian restaurant and bar at Blue Moon Crossing.",
      "poi_long_description": "Italian restaurant and bar at Blue Moon Crossing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-3bc2-712d-92fb-4f9598f70ca0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-3bc2-712d-92fb-4f9598f70ca0",
        "storage_key": "property/6767906449167577/01a086ad-3bc2-712d-92fb-4f9598f70ca0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thesauceitalian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6509705841855123761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-sauce-italian-kitchen--bar",
      "poi_latitude": "32.0806073",
      "poi_longitude": "-81.28464149999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-450-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxe8mZun-4gRMVEPKPkeV1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_15ab6029-f42a-484b-9e97-30e15b3911c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Noble Roots",
      "poi_type": "Restaurants",
      "poi_address": "100 Blue Moon Xing Ste 101, Pooler, GA 31322, USA",
      "poi_short_description": "Casual, family-owned eatery serving burgers and seafood dishes alongside vegan eats.",
      "poi_long_description": "Casual, family-owned eatery serving burgers and seafood dishes alongside vegan eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-358d-7039-957e-7bbb99b088cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-358d-7039-957e-7bbb99b088cb",
        "storage_key": "property/6767906449167577/01a086ad-358d-7039-957e-7bbb99b088cb.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.noblerootsrestaurant.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=9936992106172755296",
      "poi_directions_map_url": "https://maps.google.com/?cid=14685874441938546211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noble-roots",
      "poi_latitude": "32.0807646",
      "poi_longitude": "-81.28508599999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-495-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27BhLoCn-4gRIy687_60zss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_78a96075-e173-4ff4-acd8-cf4df29159d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Green Fire Pizza & Sports Bar",
      "poi_type": "Restaurants",
      "poi_address": "1557 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Laid-back haunt with outdoor tables & TVs for sports offering pizzeria fare & classic bar food.",
      "poi_long_description": "Laid-back haunt with outdoor tables & TVs for sports offering pizzeria fare & classic bar food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-a7ba-71d9-9151-6dd663b5ec47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-a7ba-71d9-9151-6dd663b5ec47",
        "storage_key": "property/6767906449167577/019fba08-a7ba-71d9-9151-6dd663b5ec47.webp",
        "width": 828,
        "height": 1035
      },
      "poi_business_url": "https://greenfirepizza.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17993162803635730645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-fire-pizza--sports-bar",
      "poi_latitude": "32.0921585",
      "poi_longitude": "-81.2742083",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-988-3381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZhXNW-e-4gR1bh68DyOtPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_1c24298b-0754-4341-9f31-98ad009fc1e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Wasabi Fusion",
      "poi_type": "Restaurants",
      "poi_address": "950 Morgans Corner Rd, Pooler, GA 31322, USA",
      "poi_short_description": "Low-key eatery serves Japanese & Asian dishes, such as noodle soups & sushi in unfussy digs.",
      "poi_long_description": "Low-key eatery serves Japanese & Asian dishes, such as noodle soups & sushi in unfussy digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-b5f2-77e6-b224-b64a670fd0ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-b5f2-77e6-b224-b64a670fd0ac",
        "storage_key": "property/6767906449167577/019fba08-b5f2-77e6-b224-b64a670fd0ac.webp",
        "width": 1280,
        "height": 933
      },
      "poi_business_url": "http://wasabifusionpooler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3893880621564580360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasabi-fusion",
      "poi_latitude": "32.0987236",
      "poi_longitude": "-81.2702563",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-450-0887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxkVkyCn-4gRCFIibsvXCTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_55eec0f3-d70c-4f89-9e07-4620b6b8484c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Three Tree Coffee - Porch",
      "poi_type": "Restaurants",
      "poi_address": "215 W Collins St, Pooler, GA 31322, USA",
      "poi_short_description": "Coffee shop in Pooler from the Savannah-based Three Tree Coffee roasters.",
      "poi_long_description": "Coffee shop in Pooler from the Savannah-based Three Tree Coffee roasters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-ae2e-73ac-b49c-2d1dc820a059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-ae2e-73ac-b49c-2d1dc820a059",
        "storage_key": "property/6767906449167577/019fba08-ae2e-73ac-b49c-2d1dc820a059.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://threetreecoffee.com/pages/three-tree-coffee-at-the-porch-pooler",
      "poi_directions_map_url": "https://maps.google.com/?cid=15705752762618742851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-tree-coffee---porch",
      "poi_latitude": "32.1153017",
      "poi_longitude": "-81.25136239999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-348-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-fcbc-762e-a81a-da2e7efcf3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-fcbc-762e-a81a-da2e7efcf3a5",
        "storage_key": "property/6767906449167577/019fba08-fcbc-762e-a81a-da2e7efcf3a5.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ0UlpWDOh-4gRQwgAyuwK9tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_dbc049b9-d04c-4f62-9a83-c7ad5b68ea51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Terra Mia Italian Bistro & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "1009 US-80, Pooler, GA 31322, USA",
      "poi_short_description": "Casual Italian eatery serving Neapolitan-style pizzas, calzones, pasta & classic entrees.",
      "poi_long_description": "Casual Italian eatery serving Neapolitan-style pizzas, calzones, pasta & classic entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-412c-72cf-8eaf-6bf476e5ca91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-412c-72cf-8eaf-6bf476e5ca91",
        "storage_key": "property/6767906449167577/01a086ad-412c-72cf-8eaf-6bf476e5ca91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://terramiapooler.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17523763126933024517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terra-mia-italian-bistro--pizzeria",
      "poi_latitude": "32.1104612",
      "poi_longitude": "-81.2341828",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-748-1702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYKplTyh-4gRBW_uFLjpMPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_8dc8deb4-21a3-4200-8e68-48a79bd2405c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Another Broken Egg Cafe",
      "poi_type": "Restaurants",
      "poi_address": "201C Tanger Outlets Blvd Ste. 530, Pooler, GA 31322, USA",
      "poi_short_description": "Casual chain featuring egg dishes & other breakfast items, plus brunch sandwiches.",
      "poi_long_description": "Casual chain featuring egg dishes & other breakfast items, plus brunch sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-a976-73dd-8fb5-190b528a0ede.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-a976-73dd-8fb5-190b528a0ede",
        "storage_key": "property/6767906449167577/019fba08-a976-73dd-8fb5-190b528a0ede.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anotherbrokenegg.com/locations/pooler-ga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3959289873465799763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "another-broken-egg-cafe",
      "poi_latitude": "32.13721",
      "poi_longitude": "-81.2478395",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-450-0341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9cAbROh-4gRU_S6pik58jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_b41689b6-3c92-4af4-98ea-b00e07e28ac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Carey Hilliard's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "198 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Casual joint preparing classic American fare including hickory-smoked BBQ, fried seafood & steaks.",
      "poi_long_description": "Casual joint preparing classic American fare including hickory-smoked BBQ, fried seafood & steaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-3b5e-77a9-8cf3-a358ec7c18fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-3b5e-77a9-8cf3-a358ec7c18fd",
        "storage_key": "property/6767906449167577/01a086ad-3b5e-77a9-8cf3-a358ec7c18fd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://careyhilliards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=235597526235427418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carey-hilliards-restaurant",
      "poi_latitude": "32.1422001",
      "poi_longitude": "-81.24667749999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-330-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199b-753a-a730-260f9fdb0b30",
        "storage_key": "property/6767906449167577/019fba07-199b-753a-a730-260f9fdb0b30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkX6idlah-4gRWjI5rbMCRQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_c8b82653-dc01-452d-8553-163ed2bd2689",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 Mosaic Cir, Pooler, GA 31322, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-bca8-7728-b90e-8d074c2b2267.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-bca8-7728-b90e-8d074c2b2267",
        "storage_key": "property/6767906449167577/019fba08-bca8-7728-b90e-8d074c2b2267.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/pooler-GA-1485.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=5750947757836006045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "32.0808346",
      "poi_longitude": "-81.2767039",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-348-4569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-092067e12510",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf9W7YKqn-4gRnfKkE4R4z08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_926260a0-c6a9-46fa-8d18-42a92e32c53e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Publix Super Market at Pooler Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "467 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba06-be03-7659-a223-85f3c96dfd3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba06-be03-7659-a223-85f3c96dfd3c",
        "storage_key": "property/6767906449167577/019fba06-be03-7659-a223-85f3c96dfd3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1364&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=11526382169321977680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-pooler-marketplace",
      "poi_latitude": "32.1350356",
      "poi_longitude": "-81.2511695",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-330-7313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-ecb7d3aa4229.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-ecb7d3aa4229",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-ecb7d3aa4229.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOwK6l6ym-4gRUDfVe4Pv9Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0c1bef0e-7b93-47c1-923b-d500f99dffbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "152 Traders Way, Pooler, GA 31322, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-4392-75e9-bf64-0575bc6ee5f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-4392-75e9-bf64-0575bc6ee5f3",
        "storage_key": "property/6767906449167577/01a086ad-4392-75e9-bf64-0575bc6ee5f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/pooler/152-traders-way/l958",
      "poi_directions_map_url": "https://maps.google.com/?cid=746478399867374462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "32.140139",
      "poi_longitude": "-81.25318899999999",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-ecb7d3aa4229.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-ecb7d3aa4229",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-ecb7d3aa4229.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJieh9l3in-4gRfsuYUCYGXAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_b597b933-05c4-4f58-a103-ca1afa64582b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "190 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba06-b762-7552-8172-d6940f33b301.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba06-b762-7552-8172-d6940f33b301",
        "storage_key": "property/6767906449167577/019fba06-b762-7552-8172-d6940f33b301.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.homedepot.com/l/Pooler/GA/Pooler/31322/179?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18056393580435016465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.1436729",
      "poi_longitude": "-81.24578369999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-748-1642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-092067e12510",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN497-P2j-4gREQt5Zksylfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_8c0114fd-bba7-4247-9465-c89118b21125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "160 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Discount department store with a full grocery section and pharmacy.",
      "poi_long_description": "Discount department store with a full grocery section and pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-baa0-735f-91c1-7765534dbe0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-baa0-735f-91c1-7765534dbe0c",
        "storage_key": "property/6767906449167577/019fba08-baa0-735f-91c1-7765534dbe0c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2860-pooler-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6536698602092404169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.1438926",
      "poi_longitude": "-81.2437948",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 912-748-2677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-092067e12510",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsfqmf_2j-4gRyZ2C5b4Et1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0b781f39-2114-4f75-aebb-62ffd9831303",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Tanger Outlets Savannah",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 Tanger Outlets Blvd, Pooler, GA 31322, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ab-353d-77f2-86f6-517f3c48a109.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ab-353d-77f2-86f6-517f3c48a109",
        "storage_key": "property/6767906449167577/01a086ab-353d-77f2-86f6-517f3c48a109.webp",
        "width": 700,
        "height": 525
      },
      "poi_business_url": "https://www.tangeroutlet.com/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=16473390064820136930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanger-outlets-savannah",
      "poi_latitude": "32.1346497",
      "poi_longitude": "-81.2432264",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-348-3125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-092067e12510",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-092067e12510.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJza37Jk-h-4gR4qsN9Ps8neQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_44bb660e-497a-4c70-b6a9-bc610532603b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "ExperCARE Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2201 Pooler Pkwy Ste 700, Pooler, GA 31322, USA",
      "poi_short_description": "Urgent care and primary care clinic on Pooler Parkway.",
      "poi_long_description": "Urgent care and primary care clinic on Pooler Parkway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-50d6-71ac-88f9-e9fe11e4f157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-50d6-71ac-88f9-e9fe11e4f157",
        "storage_key": "property/6767906449167577/01a086ad-50d6-71ac-88f9-e9fe11e4f157.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://expercarehealth.com/locations/pooler/?utm_source=google+business+profile&utm_medium=organic&utm_campaign=gbp&utm_content=pooler",
      "poi_directions_map_url": "https://maps.google.com/?cid=18263273054558000501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "expercare-urgent-care--primary-care",
      "poi_latitude": "32.0779281",
      "poi_longitude": "-81.2803875",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-800-6004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8AG1lWn-4gRdZXkhBQudP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8ef88237-a97c-4413-a56c-1527d70e2400",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "201 Blue Moon Xing Ste 3-4, Pooler, GA 31322, USA",
      "poi_short_description": "Fitness center featuring cardio and strength training, plus a treadmill and friendly staff.",
      "poi_long_description": "Fitness center featuring cardio and strength training, plus a treadmill and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-d865-700b-9076-28dd7e87c64a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-d865-700b-9076-28dd7e87c64a",
        "storage_key": "property/6767906449167577/019fba08-d865-700b-9076-28dd7e87c64a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/pooler-georgia-0379?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=1448677436679765954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "32.0799358",
      "poi_longitude": "-81.28437",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 912-963-7076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTrArvKn-4gRwr9rB3S8GhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ac5238b3-adcc-477c-adf7-ac7ff95ad1f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "St. Joseph's/Candler - Pooler Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "101 St Joseph's/Candler Dr, Pooler, GA 31322, USA",
      "poi_short_description": "Outpatient medical campus of the St. Joseph's/Candler health system.",
      "poi_long_description": "Outpatient medical campus of the St. Joseph's/Candler health system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-cb77-7349-8691-ae6796610cdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-cb77-7349-8691-ae6796610cdc",
        "storage_key": "property/6767906449167577/019fba08-cb77-7349-8691-ae6796610cdc.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.sjchs.org/locations/hospitals-and-facilities/pooler-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=12103041160901453872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephscandler---pooler-campus",
      "poi_latitude": "32.0896355",
      "poi_longitude": "-81.2752253",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-819-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1aQO8an-4gRMGh2qc-j9qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ce9be723-fa63-4f96-b530-fd7c26f2daf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Pooler Recreation Complex",
      "poi_type": "Health and Wellness",
      "poi_address": "200 Preston Stokes Dr, Pooler, GA 31322, USA",
      "poi_short_description": "Recreational stadium, featuring ball fields, a basketball court and playgrounds.",
      "poi_long_description": "Recreational stadium, featuring ball fields, a basketball court and playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-54be-73fe-9e3c-7475141f73e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-54be-73fe-9e3c-7475141f73e6",
        "storage_key": "property/6767906449167577/01a086ad-54be-73fe-9e3c-7475141f73e6.webp",
        "width": 1024,
        "height": 767
      },
      "poi_business_url": "http://www.poolerrec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=922756358806170625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pooler-recreation-complex",
      "poi_latitude": "32.1344032",
      "poi_longitude": "-81.26371759999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-748-5776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf4aMmrCm-4gRAezf9ARKzgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_182c9496-1210-44df-b099-b94c6d7aec03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Pooler Pkwy, Pooler, GA 31322, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-bd5b-7610-95f5-ee10b1260c01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-bd5b-7610-95f5-ee10b1260c01",
        "storage_key": "property/6767906449167577/019fba08-bd5b-7610-95f5-ee10b1260c01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/pooler-ga-pharmacies/500-pooler-hwy-pooler-ga-31322/storeid=11017?WT.mc_id=LS_GOOGLE_FS_11017",
      "poi_directions_map_url": "https://maps.google.com/?cid=10123974913545259815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.1352501",
      "poi_longitude": "-81.2556261",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-748-5170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdImsq2m-4gRJ8vUdIuVf4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_92619a66-9cbe-46ea-93e4-c1a8aef88ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1038 US-80, Pooler, GA 31322, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-d2f7-76ab-be92-5957bf3c4954.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-d2f7-76ab-be92-5957bf3c4954",
        "storage_key": "property/6767906449167577/019fba08-d2f7-76ab-be92-5957bf3c4954.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1038+w+hwy+80-pooler-ga-31322/id=18341",
      "poi_directions_map_url": "https://maps.google.com/?cid=10518339678863132855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.1232031",
      "poi_longitude": "-81.26600380000001",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-748-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVOw-oan-4gRt4iImTWm-JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_a73ff5bc-cd49-488c-a329-cb84f96f67f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "200 Tanger Outlets Blvd, Pooler, GA 31322, USA",
      "poi_short_description": "Chain fitness center at Tanger Outlets Boulevard.",
      "poi_long_description": "Chain fitness center at Tanger Outlets Boulevard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba06-cffb-7472-97eb-903776dcd6d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba06-cffb-7472-97eb-903776dcd6d3",
        "storage_key": "property/6767906449167577/019fba06-cffb-7472-97eb-903776dcd6d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/pooler-ga?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12259842723125341305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.1337583",
      "poi_longitude": "-81.2443395",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-239-5350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_rEQQCh-4gReSwLUgC2I6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_2aec96ab-8e67-48af-b8d9-ad107f9e36de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Memorial Health University Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "Full-service hospital in Savannah with a Level I trauma center.",
      "poi_long_description": "Full-service hospital in Savannah with a Level I trauma center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-e986-7000-86cf-51215fd8b577.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-e986-7000-86cf-51215fd8b577",
        "storage_key": "property/6767906449167577/019fba08-e986-7000-86cf-51215fd8b577.webp",
        "width": 564,
        "height": 317
      },
      "poi_business_url": "https://www.memorialhealth.com/locations/memorial-health-university-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320841453139011030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-health-university-medical-center",
      "poi_latitude": "32.0303424",
      "poi_longitude": "-81.089434",
      "poi_miles_from_property": "17.7 mi",
      "poi_walking_minutes": "6 hours 27 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 912-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-19d2-7548-bf24-c233282eca78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-19d2-7548-bf24-c233282eca78",
        "storage_key": "property/6767906449167577/019fba07-19d2-7548-bf24-c233282eca78.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58O7Xe51-4gR1iUiqWi29js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d1829bdb-2a68-463c-9527-2a47e2e7974f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Parker's Kitchen",
      "poi_type": "Transportation & Transit",
      "poi_address": "10 N Godley Station Blvd, Pooler, GA 31322, USA",
      "poi_short_description": "Convenience store and fuel station at Godley Station.",
      "poi_long_description": "Convenience store and fuel station at Godley Station.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-43e6-70dc-9139-75a89ee1f6ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-43e6-70dc-9139-75a89ee1f6ef",
        "storage_key": "property/6767906449167577/01a086ad-43e6-70dc-9139-75a89ee1f6ef.webp",
        "width": 1280,
        "height": 507
      },
      "poi_business_url": "https://parkerskitchen.com/locations/parkers-37/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2543971635017337232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkers-kitchen",
      "poi_latitude": "32.136122",
      "poi_longitude": "-81.25492",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-748-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-fcd0-76ea-b5a8-a6318c189239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-fcd0-76ea-b5a8-a6318c189239",
        "storage_key": "property/6767906449167577/019fba08-fcd0-76ea-b5a8-a6318c189239.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6T4U6ym-4gRkMngN7kATiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_9d18747e-af2b-4baa-b11c-f17eca5c5eac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-10d5-71a5-a600-bc2a2da69387.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-10d5-71a5-a600-bc2a2da69387",
        "storage_key": "property/6767906449167577/019fba07-10d5-71a5-a600-bc2a2da69387.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1c09-70dd-98e6-926c426824d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1c09-70dd-98e6-926c426824d0",
        "storage_key": "property/6767906449167577/019fba07-1c09-70dd-98e6-926c426824d0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_296747f2-4bcc-40ee-b42a-1cf7041fb7a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "JCB North America",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 Bamford Blvd, Pooler, GA 31322, USA",
      "poi_short_description": "North American headquarters and manufacturing plant of construction-equipment maker JCB.",
      "poi_long_description": "North American headquarters and manufacturing plant of construction-equipment maker JCB.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-66cc-747d-afea-253d508d5b94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-66cc-747d-afea-253d508d5b94",
        "storage_key": "property/6767906449167577/01a086ad-66cc-747d-afea-253d508d5b94.webp",
        "width": 1280,
        "height": 658
      },
      "poi_business_url": "https://www.jcb.com/en-US/?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8386560839779454706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jcb-north-america",
      "poi_latitude": "32.1213126",
      "poi_longitude": "-81.2352051",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-447-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR634B2uh-4gR8o5BXqYMY3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_9d33bbd0-5f4f-4954-ae2c-715d00432f16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center SAV4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 Oak Mdw Dr, Pooler, GA 31322, USA",
      "poi_short_description": "Amazon-affiliated facility for warehousing.",
      "poi_long_description": "Amazon-affiliated facility for warehousing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-e6d9-706b-802c-5eb795c6fde2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-e6d9-706b-802c-5eb795c6fde2",
        "storage_key": "property/6767906449167577/019fba08-e6d9-706b-802c-5eb795c6fde2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17744545844164534499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fulfillment-center-sav4",
      "poi_latitude": "32.0765713",
      "poi_longitude": "-81.2213927",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5ZZK7uh-4gR46APPm5KQfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_e83e5a42-3edd-455d-a6e8-8b4f095d5415",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Gulfstream Aerospace Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Gulfstream Rd, Savannah, GA 31408, USA",
      "poi_short_description": "Business-jet manufacturer headquartered beside Savannah/Hilton Head International Airport; one of the region's largest employers.",
      "poi_long_description": "Business-jet manufacturer headquartered beside Savannah/Hilton Head International Airport; one of the region's largest employers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-e597-713c-86af-5a5fa85a4024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-e597-713c-86af-5a5fa85a4024",
        "storage_key": "property/6767906449167577/019fba08-e597-713c-86af-5a5fa85a4024.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.gulfstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719559404661686851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulfstream-aerospace-corporation",
      "poi_latitude": "32.1392172",
      "poi_longitude": "-81.1973454",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 7 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-965-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeWtFyii-4gRQ8IefUphRsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d340d4de-0d70-4363-aeba-47b2ff53bff5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Georgia Ports Authority - Administrative Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 Main St, Garden City, GA 31408, USA",
      "poi_short_description": "Headquarters of the Georgia Ports Authority, operator of the Port of Savannah.",
      "poi_long_description": "Headquarters of the Georgia Ports Authority, operator of the Port of Savannah.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-e924-7677-a7ca-29c00dd8a42d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-e924-7677-a7ca-29c00dd8a42d",
        "storage_key": "property/6767906449167577/019fba08-e924-7677-a7ca-29c00dd8a42d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gaports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663778410647710348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-ports-authority---administrative-building",
      "poi_latitude": "32.1286475",
      "poi_longitude": "-81.15145869999999",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 912-964-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf78Ok-f-4gRjOpmjg1b2DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_61317ea7-65f7-406e-9cc1-bfb41437a7b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "West Chatham Elementary School",
      "poi_type": "Education",
      "poi_address": "820 Pine Barren Rd, Pooler, GA 31322, USA",
      "poi_short_description": "Public elementary school, Savannah-Chatham County Public School System.",
      "poi_long_description": "Public elementary school, Savannah-Chatham County Public School System.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wces.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11321966016882772035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-chatham-elementary-school",
      "poi_latitude": "32.0944235",
      "poi_longitude": "-81.2623169",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-395-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-eaef212efb8e",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFwvAYSyn-4gRQ4hXIxu0H50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_350e5dea-5966-4e9a-941f-79542c84ad90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "West Chatham Middle School",
      "poi_type": "Education",
      "poi_address": "800 Pine Barren Rd, Pooler, GA 31322, USA",
      "poi_short_description": "Public middle school, Savannah-Chatham County Public School System.",
      "poi_long_description": "Public middle school, Savannah-Chatham County Public School System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-c02b-71d0-b8a5-e0527bef451e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-c02b-71d0-b8a5-e0527bef451e",
        "storage_key": "property/6767906449167577/019fba08-c02b-71d0-b8a5-e0527bef451e.webp",
        "width": 641,
        "height": 1024
      },
      "poi_business_url": "http://www.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13846237724441667641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-chatham-middle-school",
      "poi_latitude": "32.0938272",
      "poi_longitude": "-81.25913770000001",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-395-3650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-eaef212efb8e",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXbnNkiyn-4gROWj1kNm3J8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4e7e5d14-fd48-4da5-9f2e-c8b533573834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Primrose School of Godley Station",
      "poi_type": "Education",
      "poi_address": "134 Traders Way, Pooler, GA 31322, USA",
      "poi_short_description": "Private preschool and child-care center (Primrose Schools).",
      "poi_long_description": "Private preschool and child-care center (Primrose Schools).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba06-c069-74a2-810b-0189da285bfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba06-c069-74a2-810b-0189da285bfc",
        "storage_key": "property/6767906449167577/019fba06-c069-74a2-810b-0189da285bfc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/godley-station/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456399615308928813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-godley-station",
      "poi_latitude": "32.1385406",
      "poi_longitude": "-81.25397799999999",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-665-8710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-eaef212efb8e",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHUatJ9On-4gRLRdJKCOZ9y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b8cd0fd8-c65b-4d03-ab4c-9af18e7cd7aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Savannah College of Art and Design",
      "poi_type": "Education",
      "poi_address": "516 Drayton St, Savannah, GA 31401, USA",
      "poi_short_description": "Private art and design university in downtown Savannah.",
      "poi_long_description": "Private art and design university in downtown Savannah.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-6580-7479-87e9-efe0a2e5c13c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-6580-7479-87e9-efe0a2e5c13c",
        "storage_key": "property/6767906449167577/01a086ad-6580-7479-87e9-efe0a2e5c13c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.scad.edu/locations/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151614706338739018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-college-of-art-and-design",
      "poi_latitude": "32.0691097",
      "poi_longitude": "-81.0938141",
      "poi_miles_from_property": "17.2 mi",
      "poi_walking_minutes": "6 hours 19 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 912-525-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-eaef212efb8e",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUzHD2me-4gRSrMTb2d95_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9981a3a8-c92b-4560-9769-ada9007e66ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Georgia Southern University Armstrong Campus Savannah",
      "poi_type": "Education",
      "poi_address": "11935 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "Georgia Southern University's Savannah campus on Abercorn Street.",
      "poi_long_description": "Georgia Southern University's Savannah campus on Abercorn Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-ea6b-748d-88ef-5e14d2feae5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-ea6b-748d-88ef-5e14d2feae5e",
        "storage_key": "property/6767906449167577/019fba08-ea6b-748d-88ef-5e14d2feae5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.georgiasouthern.edu/campuses/armstrong-campus-savannah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=783516353767565760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university-armstrong-campus-savannah",
      "poi_latitude": "31.9786073",
      "poi_longitude": "-81.1634639",
      "poi_miles_from_property": "22.4 mi",
      "poi_walking_minutes": "8 hours 12 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 912-478-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1983-7159-829d-eaef212efb8e",
        "storage_key": "property/6767906449167577/019fba07-1983-7159-829d-eaef212efb8e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9h8y0oL-4gRwGkG9vib3wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_58834af9-6b65-487d-aec2-0c65162c457e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Fun Zone",
      "poi_type": "Entertainment",
      "poi_address": "1040 US-80, Pooler, GA 31322, USA",
      "poi_short_description": "Family destination & party venue with mini-golf, go-karts, arcade games & toddler playground.",
      "poi_long_description": "Family destination & party venue with mini-golf, go-karts, arcade games & toddler playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-c6c7-732d-a2a7-496b183eb482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-c6c7-732d-a2a7-496b183eb482",
        "storage_key": "property/6767906449167577/019fba08-c6c7-732d-a2a7-496b183eb482.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://poolerfunzone.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8814177076772933745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fun-zone",
      "poi_latitude": "32.1089831",
      "poi_longitude": "-81.2293516",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-330-9860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-Iw_Beh-4gRcRBxEFo_Uno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_6acfe466-e09f-4ee8-97ca-661230ea450b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "National Museum of the Mighty Eighth Air Force",
      "poi_type": "Entertainment",
      "poi_address": "175 Bourne Ave, Pooler, GA 31322, USA",
      "poi_short_description": "90,000-sq.-ft. complex exhibiting real aircraft, images & medals from the 8th Air Force.",
      "poi_long_description": "90,000-sq.-ft. complex exhibiting real aircraft, images & medals from the 8th Air Force.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba06-c702-710f-8eff-922a504e85b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba06-c702-710f-8eff-922a504e85b0",
        "storage_key": "property/6767906449167577/019fba06-c702-710f-8eff-922a504e85b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mightyeighth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14781986351541358053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-museum-of-the-mighty-eighth-air-force",
      "poi_latitude": "32.1154483",
      "poi_longitude": "-81.2364126",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-748-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-198d-74d1-9c81-28dcc9dd1c02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-198d-74d1-9c81-28dcc9dd1c02",
        "storage_key": "property/6767906449167577/019fba07-198d-74d1-9c81-28dcc9dd1c02.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuec8DDqh-4gR5Y1LtkQqJM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_78357ff5-3474-41dc-ab42-7943166ea452",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Royal Cinemas 14 & World’s Tallest IMAX",
      "poi_type": "Entertainment",
      "poi_address": "5 Towne Center Ct, Pooler, GA 31322, USA",
      "poi_short_description": "Multiplex with casual dinner theater, IMAX & Dolby 3D options, plus beer & wine at the snack bar.",
      "poi_long_description": "Multiplex with casual dinner theater, IMAX & Dolby 3D options, plus beer & wine at the snack bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-c48d-739d-99da-ee9b73dde466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-c48d-739d-99da-ee9b73dde466",
        "storage_key": "property/6767906449167577/019fba08-c48d-739d-99da-ee9b73dde466.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.royalcinemaspooler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=509690121467810329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-cinemas-14--worlds-tallest-imax",
      "poi_latitude": "32.1468719",
      "poi_longitude": "-81.2524856",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-998-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba08-fd05-72c4-a29a-05651422a341.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-fd05-72c4-a29a-05651422a341",
        "storage_key": "property/6767906449167577/019fba08-fd05-72c4-a29a-05651422a341.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJaz2ImP-j-4gRGVKdC3fIEgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_566a69c6-e374-432b-a3c0-c1e32d96eb6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Frames n' Games",
      "poi_type": "Entertainment",
      "poi_address": "6 Towne Center Ct, Pooler, GA 31322, USA",
      "poi_short_description": "High-tech arcade games, bowling, laser tag & 5D movies for grown-ups & kids, with full bar & snacks.",
      "poi_long_description": "High-tech arcade games, bowling, laser tag & 5D movies for grown-ups & kids, with full bar & snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-487d-7671-8395-3c13b7428460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-487d-7671-8395-3c13b7428460",
        "storage_key": "property/6767906449167577/01a086ad-487d-7671-8395-3c13b7428460.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.framesngames.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11995011877853020760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frames-n-games",
      "poi_latitude": "32.1474769",
      "poi_longitude": "-81.2508895",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-330-5577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fg3kP-j-4gRWEIFKMDXdqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_e649ba4a-be77-469f-be06-135ba94bf8d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Premier Bowl & Bistro",
      "poi_type": "Entertainment",
      "poi_address": "4 Towne Center Ct, Pooler, GA 31322, USA",
      "poi_short_description": "Family-friendly hangout featuring bowling, an arcade, pizza and a bar.",
      "poi_long_description": "Family-friendly hangout featuring bowling, an arcade, pizza and a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-46f7-73ab-b45f-59a31f9d2a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-46f7-73ab-b45f-59a31f9d2a3d",
        "storage_key": "property/6767906449167577/01a086ad-46f7-73ab-b45f-59a31f9d2a3d.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.poolerbowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=490389152197816186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "premier-bowl--bistro",
      "poi_latitude": "32.1470111",
      "poi_longitude": "-81.2500167",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-348-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1982-741a-a413-056117d64219",
        "storage_key": "property/6767906449167577/019fba07-1982-741a-a413-056117d64219.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixrGqLOj-4gReq908lU2zgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_1ad3ea5e-34e1-4a80-917f-5cb09004e29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Savannah Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_long_description": "Outdoor activities such as arts & crafts, story time & water play offered for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-4e62-76c8-90e0-048a0304ffe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-4e62-76c8-90e0-048a0304ffe7",
        "storage_key": "property/6767906449167577/01a086ad-4e62-76c8-90e0-048a0304ffe7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chsgeorgia.org/SCM",
      "poi_directions_map_url": "https://maps.google.com/?cid=606148658374513045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-childrens-museum",
      "poi_latitude": "32.0760234",
      "poi_longitude": "-81.10093359999999",
      "poi_miles_from_property": "16.6 mi",
      "poi_walking_minutes": "6 hours 5 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-198d-74d1-9c81-28dcc9dd1c02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-198d-74d1-9c81-28dcc9dd1c02",
        "storage_key": "property/6767906449167577/019fba07-198d-74d1-9c81-28dcc9dd1c02.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RuwSlue-4gRlRF-R_54aQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_79f2827b-ff69-4286-96ba-95951cc53ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Grayson Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1401 E Victory Dr, Savannah, GA 31404, USA",
      "poi_short_description": "Circa-1926, 4,000-seat baseball stadium, home of  the venerable minor league team Sand Gnats.",
      "poi_long_description": "Circa-1926, 4,000-seat baseball stadium, home of  the venerable minor league team Sand Gnats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-4c57-767a-8faf-2abdc13a85bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-4c57-767a-8faf-2abdc13a85bf",
        "storage_key": "property/6767906449167577/01a086ad-4c57-767a-8faf-2abdc13a85bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thesavannahbananas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9395290885437681665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grayson-stadium",
      "poi_latitude": "32.044536",
      "poi_longitude": "-81.078662",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "6 hours 54 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 912-712-2482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-199a-756f-a324-a006243f63a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-199a-756f-a324-a006243f63a1",
        "storage_key": "property/6767906449167577/019fba07-199a-756f-a324-a006243f63a1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA3QjBwGe-4gRAXD6K0jHYoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_a424f5c4-02c6-49f1-990f-d490a9729c33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Joe Baker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "273 US-80, Pooler, GA 31322, USA",
      "poi_short_description": "City of Pooler public park on US-80.",
      "poi_long_description": "City of Pooler public park on US-80.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-58df-70ee-8f19-3365f0fb01b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-58df-70ee-8f19-3365f0fb01b0",
        "storage_key": "property/6767906449167577/01a086ad-58df-70ee-8f19-3365f0fb01b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6970821143368650746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-baker-park",
      "poi_latitude": "32.1140283",
      "poi_longitude": "-81.24362490000001",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1bf1-75ca-80e2-0c27fc439a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1bf1-75ca-80e2-0c27fc439a4a",
        "storage_key": "property/6767906449167577/019fba07-1bf1-75ca-80e2-0c27fc439a4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9GfIDGh-4gR-k9Fm-VUvWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bd57754f-8630-4ba3-a0eb-c3688a10563d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "poi_name": "Tom Triplett Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1335 US-80, Pooler, GA 31322, USA",
      "poi_short_description": "A stocked fishing lake is the draw at this tranquil park also featuring disc golf & tennis courts.",
      "poi_long_description": "A stocked fishing lake is the draw at this tranquil park also featuring disc golf & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-5468-71bd-a862-aca88bd8feea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a086ad-5468-71bd-a862-aca88bd8feea",
        "storage_key": "property/6767906449167577/01a086ad-5468-71bd-a862-aca88bd8feea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/CommunityParks/TomTriplett",
      "poi_directions_map_url": "https://maps.google.com/?cid=10772124857655829334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-triplett-community-park",
      "poi_latitude": "32.0938084",
      "poi_longitude": "-81.2129934",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-965-9629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba07-1bf1-75ca-80e2-0c27fc439a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba07-1bf1-75ca-80e2-0c27fc439a4a",
        "storage_key": "property/6767906449167577/019fba07-1bf1-75ca-80e2-0c27fc439a4a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTHK6Sl-hIgRViO7IHxGfpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_80bfd82b5bed72f648db07a9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c0a725684c4e73931eb93a3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_cc40a0ffb5c04fc31b352d27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_085207fa263ee35ab99de7f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_3fd0f94739063ddad10d956a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_9471207a15fb885b4cd43928",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "rating": "5",
      "name": "Jacqueline J",
      "text": "The property management has got a lot better over that last few months since Kaily and Gabriella have taken over. I actually can speak to someone when I call and get emails returned when there is an issues! They are doing a great job turning things around !",
      "date": "2025-11-22",
      "title": "false"
    },
    {
      "id": "ec_7b9109967d95ba1df47d635d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "rating": "5",
      "name": "Mario De La Guardia",
      "text": "Antonio and Samuel are very pleasant to deal with, and have been a great help any time my home needs servicing. Antonio returns my calls when I have left emergency maintenance requests. In my experience they have been the best maintenance team I have dealt with in all my years of renting across different companies.",
      "date": "2025-11-19",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e28d2a7b-7e54-484c-ae56-cdd7dc13dfb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Cumberland home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Cumberland",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=K9vjhx4Gryn"
    },
    {
      "id": "custom_385f5d2f-27c9-4540-938e-ce94f5209e29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Sapelo home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Sapelo",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JSj9Aj2S6VP"
    },
    {
      "id": "custom_b704dda2-04f3-40af-a29a-c6efeff1648a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Richmond Hill home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Richmond Hill",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Bt4G7sHjifC"
    }
  ],
  "faqs": [
    {
      "id": "custom_820e6708-1bfe-48cd-a689-43a49205589c",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_50720347-0ebc-4cfd-b10a-40ad69f6c060",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_5e5d7a34-3152-4641-a2a4-54d6709f1f53",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_ccb899e9-197d-4ba0-96b3-962a2c59bc40",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_777e65e6-271c-490e-8064-d7ed29eef62d",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_f917d77a-1c1a-497f-9169-5d49c5ee2e9c",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b99e5b3e-62a6-4739-9abe-d7d869584d87",
      "question": "Solar",
      "answer": "Solar Panel Fee - $50/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_29fe62a6-3660-4ca7-8648-fe95bd5b8fc8",
      "question": "Landscape Services",
      "answer": "Single-family homes: $100/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b1e67c79-8664-45d9-bda0-908410ff8a8f",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_5b39c047-90fb-4a0f-a798-27cbd7ad2fbe",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_100c9433-042c-475d-9158-d47f28222fa9",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_df516548-e81e-40b1-928b-1ceebfdacd68",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_e53165ed-16ff-4f16-968f-598b53f5b005",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_6ede820e-67bc-4731-bd3d-20f2d013ff9a",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_5565d391-bea5-4fab-9d15-2f902461c05a",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_a3f1116e-4e93-4f05-a8b5-d0ab60c3f9ec",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_334ad7f7-df9e-426e-b84c-d509d289c8c7",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_4f1773eb-9592-4194-b488-06e7be15ceb0",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_63be66f2-f86a-4a0b-b73b-3b3a0a3c4d6b",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_7683ba37-cd89-425c-b5f3-904573a75e2f",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_95314091c8fb554edfbcf57c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "yardi",
      "external_id": "2355436",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 100,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_2305bf812cffdb701971b0e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "yardi",
      "external_id": "2809790",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_319cf7ab73a81df67620e713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "yardi",
      "external_id": "2809789",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-8eb1-7109-8fb3-8f9743847262",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Drayton Park at Savannah Corners Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577"
    },
    {
      "lead_collector_id": "01a0abe0-8f3c-77df-9e8b-b3347ccfd62f",
      "lead_source": "LANDING_PAGE",
      "name": "Drayton Park at Savannah Corners Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-pooler-ga",
      "search_query": "apartments with in-unit laundry in Pooler GA",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Pooler, GA",
      "h2_subtitle": "Enjoy the luxury of apartments with in-unit laundry in Pooler, GA. Experience convenience at Quinn Residences at Drayton Park.",
      "page_copy": "Discover the luxury of living at Quinn Residences at Drayton Park, where every unit in Pooler, GA features the convenience of in-unit laundry. Our three- and four-bedroom layouts are designed with modern finishes, dual-sink vanities, and smart-home technology to enhance your living experience. In addition to the in-unit laundry, you'll enjoy a fenced yard, a 2-car garage, and other thoughtful amenities available in our community. Situated conveniently in the Pooler/Bloomingdale neighborhood, our residences offer easy access to the vibrant Savannah area. Make the smart choice and embrace full comfort while enjoying in-unit laundry facilities that make life a breeze. Schedule your tour today to see our in-unit laundry-equipped apartments firsthand!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Pooler, GA",
      "seo_description": "Discover in-unit laundry apartments in Pooler, GA at Quinn Residences. Enjoy modern layouts, smart amenities, and Savannah-area convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "luxury-apartments-air-conditioning-chatham-county",
      "search_query": "luxury apartments with air conditioning in Chatham County",
      "category": "Amenity",
      "h1_title": "Luxury A/C Apartments in Chatham County",
      "h2_subtitle": "Explore luxury apartments with air conditioning in Chatham County. Discover comfort and sophistication at Quinn Residences at Drayton Park.",
      "page_copy": "At Quinn Residences at Drayton Park, we redefine luxury living in Chatham County with meticulously designed apartments that come with air conditioning as a standard feature. Our spacious three- and four-bedroom floor plans offer refined living with modern finishes, ensuring optimum comfort and style in every corner. Each residence is equipped with smart-home technology, providing you with the convenience and efficiency that modern life demands. Additionally, our luxury apartments boast dual-sink vanities, fenced yards, and roomy 2-car garages. Nestled in the picturesque Pooler/Bloomingdale area, you'll relish the tranquil setting combined with easy access to Savannah's vibrant scene. Elevate your living experience with air-conditioned luxury and thoughtful amenities that cater to your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury A/C Apartments in Chatham County",
      "seo_description": "Experience luxury living with air-conditioned apartments in Chatham County at Quinn Residences. Modern amenities and refined comfort await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-pooler-bloomingdale",
      "search_query": "dog park apartments near Pooler/Bloomingdale",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Pooler, GA",
      "h2_subtitle": "Find pet-friendly apartments with dog parks near Pooler/Bloomingdale. Enjoy life at Quinn Residences at Drayton Park.",
      "page_copy": "Welcome to Quinn Residences at Drayton Park, where pet-friendly living near Pooler/Bloomingdale is made seamless with our on-site dog park. Our spacious three- and four-bedroom homes cater to every kind of resident, ensuring both you and your furry friends have room to roam. Each home is equipped with modern conveniences like air conditioning, dual-sink vanities, and smart-home technology while offering the privacy of fenced yards. Located strategically in the Pooler/Bloomingdale neighborhood, residents enjoy refreshing walks with their pets in a vibrant community setting, along with easy access to Savannah’s array of activities. Discover the perfect balance of luxury and pet-friendliness in our dog park apartments today, and let your pets enjoy the freedom they deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Pooler, GA",
      "seo_description": "Discover pet-friendly apartments near Pooler/Bloomingdale at Quinn Residences with a dog park. Spacious, modern homes fit for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "apartments-pool-access-pooler-ga",
      "search_query": "apartments with pool access in Pooler GA",
      "category": "Amenity",
      "h1_title": "Pool Access Apartments in Pooler, GA",
      "h2_subtitle": "Enjoy the best of apartments with pool access in Pooler, GA. Dive into comfort at Quinn Residences at Drayton Park.",
      "page_copy": "Quinn Residences at Drayton Park offers a relaxing haven in Pooler, GA, where residents can enjoy pool access as part of the premium amenities. Our elegantly designed three- and four-bedroom homes blend modern aesthetics with functionality, featuring air conditioning, dual-sink vanities, and smart-home technology. Just a short swim away, residents relish in a leisurely lifestyle where their backyard extends beyond the private fenced areas. Situated in the heart of the Pooler/Bloomingdale neighborhood, these residences provide convenient access to local Savannah highlights while offering tranquil retreats from the hustle and bustle. Consider making Quinn Residences your home and create lasting memories in our pool-access community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Access Apartments in Pooler, GA",
      "seo_description": "Find pool access apartments in Pooler, GA at Quinn Residences. Modern homes with prime amenities for a refreshing lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "modern-apartments-with-dishwasher-31322",
      "search_query": "modern apartments with dishwasher in 31322",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Dishwasher 31322",
      "h2_subtitle": "Discover modern apartments with dishwasher amenities in the 31322 area. Experience added convenience at Quinn Residences at Drayton Park.",
      "page_copy": "Quinn Residences at Drayton Park in Pooler, GA, captures the essence of modern living with apartments expertly fitted with dishwashers, enhancing everyday convenience in the 31322 area. Offering spacious three- and four-bedroom layouts, each home combines smart-home technology and elegant design, creating a comfortable ambiance. Residents are treated to air conditioning, dual-sink vanities, and two-car garages, ensuring convenience and luxury at every turn. Located in the vibrant Pooler/Bloomingdale vicinity, these apartments provide easy access to Savannah's cultural and recreational offerings, all while nestled in a peaceful neighborhood. Embrace the elevated lifestyle and see how modern conveniences like dishwashers can redefine your home experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwasher 31322",
      "seo_description": "Enjoy modern living in 31322 with apartments featuring dishwashers at Quinn Residences. Convenience and comfort in Pooler, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-pooler-ga",
      "search_query": "three bedroom apartments in Pooler GA",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Pooler, GA",
      "h2_subtitle": "Explore spacious three bedroom apartments in Pooler, GA. Find your new home at Quinn Residences at Drayton Park.",
      "page_copy": "Experience the comfort and space available at Quinn Residences at Drayton Park with our thoughtfully designed three bedroom apartments in Pooler, GA. Each room offers ample space and is designed with modern finishes, making it ideal for families and those who love extra room. Revel in conveniences like dual-sink vanities, air conditioning, and private fenced yards. Additionally, two-car garages and smart-home technology enhance living comfort. Located in the vibrant Pooler/Bloomingdale community, our residences provide seamless access to Savannah-area amenities while offering a peaceful retreat at the end of the day. Schedule a tour and witness the perfect fusion of space, style, and convenience at Quinn Residences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Pooler, GA",
      "seo_description": "Discover spacious living with three bedroom apartments in Pooler, GA at Quinn Residences. Modern design and prime amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "four-bedroom-rentals-chatham-county",
      "search_query": "four bedroom rentals Chatham County",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Rentals in Chatham County",
      "h2_subtitle": "Find spacious four bedroom rentals in Chatham County. Quinn Residences at Drayton Park offers the perfect blend of comfort and modern living.",
      "page_copy": "For those seeking generous living space in Chatham County, Quinn Residences at Drayton Park provides impeccably designed four bedroom rentals. These homes offer spacious interiors, perfect for growing families or anyone looking for extra room. Each residence comes equipped with dual-sink vanities and smart-home technology, enhancing functional living. The properties include private fenced yards and two-car garages for added convenience. Situated in the Pooler/Bloomingdale neighborhood, these rentals offer easy access to local amenities and Savannah's attractions while maintaining a serene residential feel. Visit Quinn Residences and discover why our four bedroom homes are ideal for anyone seeking comfort and luxury in Chatham County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Rentals in Chatham County",
      "seo_description": "Explore four bedroom rentals in Chatham County at Quinn Residences. Spacious and modern homes perfect for families seeking comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "apartments-near-west-chatham-elementary-school",
      "search_query": "apartments near West Chatham Elementary School Pooler GA",
      "category": "School",
      "h1_title": "Apartments Near West Chatham Elementary School",
      "h2_subtitle": "Discover family-friendly apartments near West Chatham Elementary School in Pooler, GA. Quinn Residences at Drayton Park offers the ideal location.",
      "page_copy": "Situated conveniently near West Chatham Elementary School, Quinn Residences at Drayton Park provides the perfect family-friendly living option in Pooler, GA. Our three- and four-bedroom homes are designed with modern amenities such as smart-home technology and dual-sink vanities, ensuring a comfortable lifestyle. Families will love the private fenced yards, ideal for outdoor play, and two-car garages for ample parking. Located in the Pooler/Bloomingdale area, residents enjoy easy access to both educational and recreational facilities, making it a desirable place to call home. Experience the perfect blend of convenience, comfort, and community at Quinn Residences, located just a short drive from West Chatham Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near West Chatham Elementary School",
      "seo_description": "Find your next home near West Chatham Elementary School. Quinn Residences in Pooler, GA, offers family-friendly living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "rentals-close-west-chatham-middle-school",
      "search_query": "rentals close to West Chatham Middle School Chatham County",
      "category": "School",
      "h1_title": "Rentals Close to West Chatham Middle School",
      "h2_subtitle": "Explore ideal rentals close to West Chatham Middle School in Chatham County. Quinn Residences at Drayton Park offers a prime location and modern amenities.",
      "page_copy": "For families prioritizing access to quality education, Quinn Residences at Drayton Park is conveniently located close to West Chatham Middle School in Chatham County. Our community offers three- and four-bedroom rentals that are perfect for family living. Each home features modern designs, including dual-sink vanities and advanced smart-home technology, along with private fenced yards and spacious two-car garages. Located in the heart of the Pooler/Bloomingdale neighborhood, residents benefit from proximity to educational institutions as well as various local amenities and recreational spots. Discover the ideal home that combines location, convenience, and modern living at Quinn Residences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to West Chatham Middle School",
      "seo_description": "Find rentals near West Chatham Middle School. Discover Quinn Residences in Chatham County, where convenience meets modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "apartments-near-savannah-college-art-design",
      "search_query": "apartments near Savannah College of Art and Design",
      "category": "School",
      "h1_title": "Apartments Near Savannah College of Art and Design",
      "h2_subtitle": "Looking for apartments near Savannah College of Art and Design? Quinn Residences at Drayton Park offers spacious living with an ideal location.",
      "page_copy": "Quinn Residences at Drayton Park is the perfect choice for students and professionals seeking apartments near Savannah College of Art and Design. Our three- and four-bedroom homes provide ample space, modern amenities, and a vibrant community atmosphere. Each residence is equipped with smart-home technology, dual-sink vanities, and fenced yards, ensuring both comfort and style. Situated in the Pooler/Bloomingdale neighborhood, our properties offer a convenient commute to SCAD, along with access to all the cultural and artistic offerings of the Savannah area. Whether you're a student or faculty member, Quinn Residences delivers both convenience and comfort near SCAD.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Savannah College of Art and Design",
      "seo_description": "Discover Quinn Residences near Savannah College of Art and Design. Ideal living with spacious homes and modern amenities in Pooler, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "housing-options-near-georgia-southern-armstrong-campus",
      "search_query": "housing options near Georgia Southern University Armstrong Campus Savannah",
      "category": "School",
      "h1_title": "Housing Near Georgia Southern Armstrong Campus",
      "h2_subtitle": "Explore housing options near Georgia Southern University Armstrong Campus in Savannah. Quinn Residences offers comfort and convenience.",
      "page_copy": "For students and faculty of Georgia Southern University Armstrong Campus seeking nearby housing options, Quinn Residences at Drayton Park presents an ideal choice. Our community offers spacious three- and four-bedroom homes designed with modern finishes and a host of amenities such as smart-home technology and dual-sink vanities. Residents can enjoy private fenced yards and spacious two-car garages, providing both comfort and convenience. Located within the vibrant Pooler/Bloomingdale area, the Residences offer easy access to the Armstrong Campus and a quick commute to all that Savannah has to offer. Experience exceptional living conditions with proximity to campus, making daily commutes effortless and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Georgia Southern Armstrong Campus",
      "seo_description": "Find housing options near Georgia Southern University Armstrong Campus. Quinn Residences offers spacious homes and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "apartments-near-memorial-health-university-medical-center",
      "search_query": "apartments near Memorial Health University Medical Center Pooler GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Memorial Health University",
      "h2_subtitle": "Looking for apartments near Memorial Health University Medical Center in Pooler, GA? Discover comfortable living at Quinn Residences at Drayton Park.",
      "page_copy": "Healthcare professionals and staff seeking proximity to Memorial Health University Medical Center in Pooler, GA will find Quinn Residences at Drayton Park an ideal option. Our expansive three- and four-bedroom apartments feature modern amenities such as smart-home technology, dual-sink vanities, and private fenced yards. Located in the Pooler/Bloomingdale area, the Residences offer a convenient commute to the medical center while providing serene neighborhood living. With secure two-car garages and beautifully maintained lawns, Quinn Residences ensures both comfort and peace of mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Health University",
      "seo_description": "Find modern apartments near Memorial Health University Medical Center in Pooler, GA. Quinn Residences offers ideal living conditions for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "apartments-near-joe-baker-park-pooler",
      "search_query": "apartments near Joe Baker Park Pooler",
      "category": "Park",
      "h1_title": "Apartments Near Joe Baker Park Pooler",
      "h2_subtitle": "Discover apartments near Joe Baker Park in Pooler. Enjoy a blend of suburban tranquility and modern convenience at Quinn Residences.",
      "page_copy": "For those seeking a home near Joe Baker Park in Pooler, Quinn Residences at Drayton Park provides the ideal living solution. Our spacious three- and four-bedroom layouts cater to families and individuals alike, offering modern finishes and a community rich in amenities. Enjoy the convenience of smart-home technology, dual-sink vanities, and fenced yards perfect for pet-friendly living. Located in the charming Pooler/Bloomingdale neighborhood, the Residences ensure easy access to Joe Baker Park and other local attractions while providing a tranquil suburban retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Joe Baker Park Pooler",
      "seo_description": "Looking for a home near Joe Baker Park in Pooler? Choose Quinn Residences for modern living and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167577",
      "source": "generator",
      "page_item_url": "rental-homes-near-tom-triplett-park-chatham-county",
      "search_query": "rental homes close to Tom Triplett Community Park Chatham County",
      "category": "Park",
      "h1_title": "Rental Homes Near Tom Triplett Community Park",
      "h2_subtitle": "Explore rental homes close to Tom Triplett Community Park in Chatham County. Enjoy modern living at Quinn Residences.",
      "page_copy": "Quinn Residences at Drayton Park offers an exceptional selection of rental homes close to Tom Triplett Community Park in Chatham County. Residents can choose from three- or four-bedroom designs that feature modern comforts such as a dual-sink vanity, smart-home technology, and spacious fenced yards. Located in the Pooler/Bloomingdale neighborhood, our community provides easy access to Tom Triplett Community Park, allowing you to enjoy the beautiful walking trails and recreational activities available. Combine the tranquility of park-side living with the convenience of nearby Savannah-area connections.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and winding streets.",
        "public_id": "019fba10-1dc4-75be-9fb8-feed83a025ec",
        "storage_key": "property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp",
        "width": 1280,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Tom Triplett Community Park",
      "seo_description": "Find rental homes close to Tom Triplett Community Park in Chatham County. Enjoy modern living and tranquil surroundings at Quinn Residences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977247872"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M4SR4WCJ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57146903863"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn5oq5wd2"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ad688957-d1b5-44ac-9c77-fa7bdcb5c413/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f5761ef0-ff93-11ef-945e-bf2a86164798"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-706-9917"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "844-739-0193"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977247872",
  "custom_google_gtm_id": "GTM-M4SR4WCJ",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57146903863",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn5oq5wd2",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ad688957-d1b5-44ac-9c77-fa7bdcb5c413/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f5761ef0-ff93-11ef-945e-bf2a86164798",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "866-706-9917",
  "custom_paid_social_tracking_phone_number": "844-739-0193",
  "custom_audioeye_site_id": "1d9c5d8a-91b5-410c-80c9-ebfde2ab0b46",
  "custom_audioeye_site_hash": "c635eef051f9631261dd1e5f88a305bc"
};

export const generatedAt = '2026-10-29T18:34:48.391Z';
